import React, { useEffect } from "react";
import classNames from "classnames";
import Styles from "./Payment.module.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { Bind, checkUserId } from "../BGService/kzgAPI";

import qs from "qs";
import CountdownTimer from "../../Component/CountdownTimer/CountdownTimer";

const BindCases = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState([]);
  const location = useLocation();
  // location.search 會得到 "?a=1&b=2"
  const queryParams = qs.parse(location?.search, { ignoreQueryPrefix: true });

  // 🔹 新增一列
  const handleAddRow = () => {
    setData([...data, { caseId: "", caseName: "", fromBackend: false }]);
  };

  // 🔹 刪除一列
  const handleDeleteRow = (index) => {
    setData(data.filter((_, i) => i !== index));
  };

  // 🔹 更新欄位內容
  const handleChange = (index, field, value) => {
    const newData = [...data];
    newData[index][field] = value;
    setData(newData);
  };

  const handleBind = () => {
    // 🔹 驗證每一列的 caseId 是否為空
    const hasEmptyCaseId = data.some((item) => !item.caseId.trim());

    if (hasEmptyCaseId) {
      alert("❌ 請確認所有個案的身分證欄位皆已填寫！");
    } else {
      FetchBind(
        atob(queryParams?.userId).split("-")[0],
        data.map((item) => item.caseId)
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("所有欄位內容：", data);
  };

  /**
   * Async Function
   */

  async function CheckUserId(userId) {
    const response = await checkUserId({
      userId: userId,
    });
    if (response.status === 50004) {
    } else if (response.status !== 200) {
      // navigate(`/payment_temp`);
    } else {
      setData(response.data);
    }
  }

  async function FetchBind(userId, caseIds) {
    const response = await Bind({
      userId: userId,
      caseIds: caseIds,
    });
    if (response.status !== 200) {
      alert(response.errorMessage);
    } else {
      alert("綁定成功!");
      CheckUserId(userId);
    }
  }

  /**
   * use Effect
   */
  useEffect(() => {
    CheckUserId(atob(queryParams?.userId).split("-")[0]);
  }, []);

  // useEffect(() => {
  //     navigate("/systemRepair")
  //   }, []);

  /**
   * Handling
   */

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#e6ecef",
        marginTop: "2vh",
      }}
    >
      <div className={classNames("container")}>
        <div
          className={classNames(Styles.payment__info__method__btn)}
          // onClick={() => navigate(`/payment_temp`)}
        >
          {queryParams?.userId ? (
            <div>
              <h1 className="mb-2" style={{fontWeight:"800"}}>綁定個案專屬頁面</h1>
              <CountdownTimer
                startTime={atob(queryParams?.userId).split("-")[1]}
              />
            </div>
          ) : null}
        </div>

        <div className={classNames(Styles.payment__info)}>
          <div className={classNames("col-sm-12", "col-md-12", "col-lg-12")}>
            <form onSubmit={handleSubmit}>
              <table style={{ margin: "0 auto" }}>
                <thead>
                  <tr>
                    <th
                      className={classNames(Styles.payment__info__table__head)}
                    >
                      個案身分證
                    </th>
                    <th
                      className={classNames(Styles.payment__info__table__head)}
                    >
                      個案姓名
                    </th>

                    <th
                      className={classNames(Styles.payment__info__table__head)}
                    ></th>
                  </tr>
                </thead>

                <tbody>
                  {data?.map((info, index) => {
                    return (
                      <tr key={index}>
                        <td
                          className={classNames(
                            Styles.payment__info__table__content
                          )}
                        >
                          <input
                            disabled={info.fromBackend !== false}
                            defaultValue={info.caseId}
                            onChange={(e) =>
                              handleChange(index, "caseId", e.target.value)
                            }
                          />
                        </td>
                        <td
                          className={classNames(
                            Styles.payment__info__table__content
                          )}
                        >
                          {info.caseName}
                        </td>

                        <td
                          className={classNames(
                            Styles.payment__info__table__content
                          )}
                        >
                          <div
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDeleteRow(index)}
                          >
                            刪除
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <h5
                style={{
                  margin: "2vh auto",
                  padding: "8px 16px",
                  backgroundColor: "#a3a3a3ff",
                  color: "#000000",
                  textAlign: "center"
                }}
              >
                ⚠️請按下儲存鍵!!出現綁定成功才算成功唷!
              </h5>
              {/* 新增按鈕 */}
              <div style={{ textAlign: "center", marginTop: "1rem" }}>
                <button
                  type="button"
                  onClick={handleAddRow}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#a3a3a3ff",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  新增個案
                </button>
                <button
                  type="submit"
                  onClick={handleBind}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#5c7a88ff",
                    marginLeft: "3vh",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  儲存
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BindCases;
